import React, { useState } from 'react';
import { parseClue } from './clueUtils';
import ClueIcons from './ClueIcons';
import '../../styles/CluePreview.css';

// The icon clue as the app draws it, in a 32px box; click to toggle light/dark.
const CluePreview = ({ clue }) => {
  const [isDark, setIsDark] = useState(false);
  const parsed = parseClue(clue);

  if (parsed.type !== 'icons') return null;

  return (
    <div
      className={`clue-preview ${isDark ? 'dark' : 'light'}`}
      onClick={() => setIsDark(!isDark)}
      title="Click to toggle light/dark preview"
    >
      <ClueIcons
        parsed={parsed}
        size={32}
        maxWidth={96}
        maxHeight={32}
        imageFilter={isDark ? 'brightness(0) invert(1)' : 'brightness(0)'}
      />
    </div>
  );
};

export default CluePreview;
